module.exports = __webpack_public_path__ + "img/skyhub-logo.b8eb9cfb.png";